<template>
	<div class="flex warp header v-center flex-bettwen" style="height: 100px;">
		<div class="logo"><a><img src="../assets/logo.png" style="height: 80px;" /></a></div>
		<div class="flex v-center">
			<div style="height: 100px;">
				<ul class="menus">
					<li class="menu-item" v-for="(item,index) in menus" :key="index">
						<router-link :to="{path:item.path}">{{item.label}}</router-link>
						<ul class="dropdown-menu" v-if="item.children">
							<li v-for="(i,index) in item.children" :key="index">
								<router-link :to="{name:i.name,query:{tab:i.tab}}">{{i.label}}</router-link>
							</li>
						</ul>
					</li>

				</ul>
			</div>
			<div style="width: 130px;" ><a href="http://39.102.102.195:8080/login" target="_blank" style="color: #333;" class="flex v-center"><img width="40" src="../assets/new/bangong.png" style="margin-right: 10px;"/>电子办公</a></div>
		</div>

	</div>

</template>

<script>
	import {
		h,
		ref
	} from 'vue'
	export default {
		setup() {
			let activeKey = 'ref';
			let menus = [{
					label: '首页',
					path: '/home',
					//icon: renderIcon(BookIcon)
				},
				{
					label: '关于我们',
					path: '/about',
					children: [{
						label: '公司简介',
						name: 'about',
						tab: 0
					}, {
						label: '组织结构',
						name: 'about',
						tab: 1
					}, {
						label: '企业资质',
						name: 'about',
						tab: 2
					}, {
						label: '业务范围',
						name: 'about',
						tab: 3
					}, {
						label: '服务内容',
						name: 'about',
						tab: 4
					}]
				},
				{
					label: '新闻资讯',
					path: 'news',
					children: [{
						label: '公司动态',
						name: 'news',
						tab: 0
					}, {
						label: '项目动态',
						name: 'news',
						tab: 1
					},{
						label: '党建活动',
						name: 'news',
						tab: 2
					}]
				},
				{
					label: '典型业绩',
					path: 'product',
					children: [{
						label: '全过程咨询',
						name: 'product',
						tab: 0
					}, {
						label: '造价咨询',
						name: 'product',
						tab: 1
					}, {
						label: '招标代理',
						name: 'product',
						tab: 2
					}, {
						label: '工程监理',
						name: 'product',
						tab: 3
					}]
				},
				{
					label: '公司荣誉',
					path: 'honor',
					//icon: renderIcon(BookIcon),
				},

				{
					label: '企业文化',
					path: 'culture',
					children: [{
						label: '企业文化',
						name: 'culture',
						tab: 0
					}, {
						label: '企业战略',
						name: 'culture',
						tab: 1
					}]
				},
				{
					label: '联系我们',
					path: 'contact',
					children: [{
						label: '联系我们',
						name: 'contact',
						tab: 0
					}, {
						label: '加入我们',
						name: 'contact',
						tab: 1
					}]
				},
			]
			return {
				activeKey,
				menus
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
	.header {
		//height: 100px;
		z-index: 9999;
		position: relative;

		.logo {
			width: 300px;
			margin-left: 30px;
		}

		.login_btn {
			font-size: 12px;
			color: #333;
			width: 56px;
			height: 28px;
			letter-spacing: 1px;
			// background: #ef8518;
			border: hidden;
			padding: 10px 15px;
		}

		.menus {
			//display: flex;
			height: 100%;
			margin: 0 52px;
			padding: 0;

			li.menu-item:hover {
				ul {
					display: block;
				}
			}

			.menu-item {
				display: block;
				list-style: none;
				margin-right: 1px;
				position: relative;
				float: left;

				&>a {
					// padding-bottom: 10px;
					line-height: 22px;
					font-size: 17px;
					display: block;
					color: #333;
					height: 20px;
					width: 100px;
					text-align: center;
					padding: 40px 0;
				}

				ul {
					border: none;
					padding: 0;
					background: #c30d23;

					li>a {
						padding: 10px;
						color: #fff;
						font-size: 15px;
					}

					li>a:hover {
						background: #900d10;
					}
				}

			}

			.dropdown-menu {
				position: absolute;
				top: 100%;
				left: 0;
				z-index: 1000;
				display: none;
				float: left;
				min-width: 160px;
				padding: 5px 0;
				//margin: 2px 0 0;
				list-style: none;
				font-size: 16px;
				text-align: left;
				background-color: #ffffff;
				border: 1px solid #cccccc;
				border: 1px solid rgba(0, 0, 0, 0.15);
				//border-radius: 4px;

				box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
				background-clip: padding-box;

				li>a {
					display: block;
					padding: 3px 20px;
					clear: both;
					font-weight: normal;
					line-height: 1.42857143;
					color: #333333;
					white-space: nowrap;
				}
			}

			.menu-item:hover {
				a {
					color: #fff;
				}

				//border-bottom: 5px solid #004694;
				background: #c30d23;
				border-bottom-color: #900d10;
			}

			.menu-item a:hover {
				//border-bottom: 5px solid #004694;
				background: #c30d23;
				border-bottom-color: #900d10;
			}
		}

	}
</style>